import AbstractService from "../AbstractService";

class BaseExpeditionService extends AbstractService {

  static listEndpoint = '';
  static additionalInfoEndpoint = '';


  static _getUrl(partUrl) {
    return `/rest/v1/customer/data/expedition${partUrl}`;
  }

  static async getExpeditionsFlags() {

    const url = this._getUrl(`/get-expeditions-flags`);
    const resp = await this._getResource(url);

    return {
      data: resp.results
    };
  }

  static async getList(params) {
    const { pageSize, urlParam } = this._getPageSizeUrlParamList(params);
    const url = this._getUrl(`/${this.listEndpoint}${urlParam}`);
    const resp = await this._getResource(url);
    return {
      pageSize: pageSize,
      totalCount: resp.count,
      data: resp.results
    };
  }
  static async getAdditionalInfo(itemId) {
    const url = this._getUrl(`/${itemId}/${this.additionalInfoEndpoint}`);
    const resp = await this._getResource(url);
    return {
      data: resp.results
    };
  }



}


export default BaseExpeditionService;